export function loadGroups(detail) {
  return {
    type: 'LOAD_GROUPS',
    detail,
  };
}
